export default __webpack_public_path__ + "static/media/empty-dashboard-switch.e0f978f0.svg";